import { useContext } from 'react'
import { OfflineContext } from 'contexts/offlineContext'

export const useOfflineContext = () => useContext(OfflineContext)
